type Language = 'EN' | 'JA';

export const AVAILABLE_LANGUAGES: Language[] = ['EN', 'JA'];

const LANGUAGE_MAPPING = {
  EN: 'en-US',
  JA: 'ja-JP',
};

export const toTransalation = (lang: Language): string => {
  return LANGUAGE_MAPPING[lang] || 'en-US';
};

export const toLanguage = (value: string): Language => {
  if (value === 'EN' || value === 'JA') {
    return value;
  }

  throw new Error();
};

export default Language;
